import React from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

import classnames from 'classnames'

const Switch = (props) => {
  const className = classnames({
    'ui-switch': true,
    'ui-switch--on': props.required,
    'ui-switch--off': !props.required
  })

  return (
    <div className={className} onClick={() => props.toggleSwitch(!props.required)} />
  )
}

Switch.propTypes = {
  required: PropTypes.bool,
  toggleSwitch: PropTypes.func
}

Switch.defaultProps = {
  required: false,
  toggleSwitch: function() {}
}

export default Switch



// WEBPACK FOOTER //
// ./src/components/common/switch.js